import { render, staticRenderFns } from "./addAttr.vue?vue&type=template&id=1c227b25&"
import script from "./addAttr.vue?vue&type=script&lang=js&"
export * from "./addAttr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports